import { shellLocalConfig } from '@src/config/shell/localConfig';
import { RouteName } from '@src/app/router/constants/RouteName';
import { currentSite } from '@src/app/utils/domainHelpers';
import { useVueRouter } from '@superbet-group/web.lib.vue-utilities';
import {
    Country,
    Site,
} from '@superbet-group/web.types';
import { onBeforeMount } from '@vue/composition-api';
import { ShellRemoteConfigDto } from '@src/config/shell/remoteConfigTypes';
import { getShellConfig } from '@src/config/shell/config';
import { getConfig } from '@superbet-group/web.lib.config';

export const useHasSocialRouteGuard = (routeName = RouteName.App.Home) => {
    const { router } = useVueRouter();

    onBeforeMount(() => {
        if (!isSocialEnabledOrAppEnabled()) {
            router.value.push({ name: routeName });
        }
    });
};

/**
 * Determines whether social is enabled depending on local and remote config.
 */
export function getIsSocialEnabled(remoteConfig: ShellRemoteConfigDto) {
    return !!(shellLocalConfig.hasSocialFederation && remoteConfig.isSocialEnabled);
}

export function getIsSocialAppEnabled(remoteConfig: ShellRemoteConfigDto) {
    return !!(shellLocalConfig.hasSocialFederation && remoteConfig.isSocialAppEnabled);
}

export function isBelgiumGamingSite() {
    // Disable Social for Belgium gaming sites (van hecke)
    // eslint-disable-next-line sonarjs/prefer-single-boolean-return
    if (getConfig().countrySpecific.country === Country.Be && currentSite !== Site.NapoleonSports) {
        return true;
    }

    return false;
}

export function isSocialEnabled() {
    if (isBelgiumGamingSite()) {
        return false;
    }
    return getShellConfig().remoteConfig.social.isSocialEnabled;
}

export function isSocialAppEnabled() {
    if (isBelgiumGamingSite()) {
        return false;
    }
    return getShellConfig().remoteConfig.social.isSocialAppEnabled;
}

export function isSocialEnabledOrAppEnabled() {
    return isSocialEnabled() || isSocialAppEnabled();
}

export function isSocialEnabledAndIsGamingBe() {
    if (isBelgiumGamingSite()) {
        return getShellConfig().remoteConfig.social.isSocialEnabled;
    }
    return false;
}

export function isSocialAppEnabledAndIsGamingBe() {
    if (isBelgiumGamingSite()) {
        return getShellConfig().remoteConfig.social.isSocialAppEnabled;
    }
    return false;
}

export function isSocialEnabledOrAppEnabledAndIsGamingBe() {
    return isSocialEnabledAndIsGamingBe() || isSocialAppEnabledAndIsGamingBe();
}

export function isSuperSocialMainProduct() {
    return getConfig().countrySpecific.country === Country.BrSocial;
}
